import React from 'react';
import { DoodleStar } from '../brand/Doodles';
type ScriptEyebrowProps = {
  children: React.ReactNode;
  /** Accent color for the small companion doodle. */
  accent?: string;
  className?: string;
};

/**
 * The site's script accent system: a small hand-written label that sits directly
 * above a section's main heading, always paired with one tiny hand-drawn mark.
 * Used on a handful of emotionally focused sections only — never for navigation,
 * buttons, dates, times, locations, or body copy.
 */
export function ScriptEyebrow({
  children,
  accent = 'var(--bcm-yellow)',
  className = ''
}: ScriptEyebrowProps) {
  return <p className={`flex items-center gap-2 font-script text-[1.75rem] leading-none text-brand-navy sm:text-3xl ${className}`} data-id="element-370" data-mp="3va5cmpkgp150">
      <DoodleStar className="h-4 w-4 shrink-0 sm:h-5 sm:w-5" color={accent} data-id="element-371" data-mp="rty8yj21r3w8" />
      {children}
    </p>;
}